import { render, staticRenderFns } from "./Melit.vue?vue&type=template&id=fe13dd60"
import script from "./Melit.vue?vue&type=script&lang=js"
export * from "./Melit.vue?vue&type=script&lang=js"
import style0 from "./Melit.vue?vue&type=style&index=0&id=fe13dd60&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports